// ui-profile-form.js

export const pendingProfiles = [];

/**
 * Add a new profile to the pending list
 */
export function addProfile(name, norm) {
  if (!name || !norm) {
    alert('Please fill in both Name and Norm.');
    return;
  }

  pendingProfiles.push({ name, norm });
}

/**
 * Reset input fields
 */
export function resetProfileForm() {
  document.getElementById('setup-profile-name').value = '';
  document.getElementById('setup-profile-norm').value = '';
}

/**
 * Render preview tags in #profile-tags
 */
export function renderProfilePreview() {
  const tagContainer = document.getElementById('setup-profile-tags');
  tagContainer.innerHTML = '';

  pendingProfiles.forEach((profile, index) => {
    const tag = document.createElement('div');
    tag.className = 'setup-profile-tag';
    tag.innerHTML = `
      ${profile.name} (${profile.norm})
      <button class="remove-tag" title="Remove" data-index="${index}">&times;</button>
    `;
    tagContainer.appendChild(tag);
  });

  tagContainer.querySelectorAll('.remove-tag').forEach(btn => {
    btn.addEventListener('click', () => {
      const i = Number(btn.dataset.index);
      pendingProfiles.splice(i, 1);
      renderProfilePreview();
    });
  });
}